/**
 * Created by Mateusz Lipowski on 28.11.2016.
 */


namespace Action.Other {
    export class CategoryEdit extends Action.UserActionBase {
        protected formSender: Logic.FormSender = null;
        protected window: Entity.View.Window.Window = null;
        protected category: Entity.Map.Type.Category = null;
        protected form: HTMLFormElement = null;
        protected deleteButton: HTMLInputElement = null;

        public constructor(event: Action.UserActionEvent) {
            super(event);
        }

        public execute(): void {
            this.category = this.event.target as Entity.Map.Type.Category;
            this.window = App.getInstance().service.windowContainer.createWindow();
            this.window.show('category_edit');
            this.form = this.window.getForm();
            this.deleteButton = this.form['delete'] as HTMLInputElement;

            this.deleteButton.addEventListener('click', (e: MouseEvent): void => {
                if(confirm('Na pewno?')) {
                    this.sendDeleteRequest();
                }
            });

            this.initView();
            this.initFormSender();
        }

        protected initView(): void {
            this.form['id']['value'] = this.category.id;
            this.form['name']['value'] = this.category.name;
            this.form['color'].value = '#' + this.category.color;
            this.form['priority'].value = this.category.priority.toString();
        }

        protected initFormSender() {
            this.formSender = new Logic.FormSender(this.form, (action: string, fields: Object, response: any): void => {
                let alert: Entity.View.Alert;
                if(this.formSender.isError())
                    alert = new Entity.View.Alert(Entity.View.AlertType.ERROR, this.formSender.getMessage());
                else {
                    this.category.name = this.form['name']['value'];
                    this.category.color = this.form['color'].value.substring(1);
                    this.category.priority = parseInt(this.form['priority'].value);
                    this.app.service.callbackContainer.invokeCallbacks('category', new Control.CallbackContainer.Event('update', this.category, {}));

                    for(let deviceNode of this.app.entityContainer.findNodesByCategoryId(this.category.id)) {
                        if(!deviceNode)
                            continue;

                        deviceNode.update();
                    }

                    for(let link of this.app.entityContainer.findLinksByCategoryId(this.category.id)) {
                        if(!link)
                            continue;

                        link.update();
                    }

                    alert = new Entity.View.Alert(Entity.View.AlertType.SUCCESS, this.formSender.getMessage());
                    this.formSender.dispose();
                    this.window.dismiss();
                }
                alert.show();
            });
        }

        protected sendDeleteRequest(): void {
            let requestSender: Logic.RequestSender = new Logic.RequestSender();
            requestSender.sendRequest('DeleteCategory', {id: this.category.id}, (action: string, fields: Object, response: any): void => {
                let alert: Entity.View.Alert;
                if(requestSender.isError())
                    alert = new Entity.View.Alert(Entity.View.AlertType.ERROR, requestSender.getMessage());
                else {
                    this.app.entityContainer.deleteCategory(this.category.id);
                    this.app.service.callbackContainer.invokeCallbacks('category', new Control.CallbackContainer.Event('delete', this.category, {}));
                    this.app.service.callbackContainer.invokeCallbacks('category', new Control.CallbackContainer.Event('update', this.category, {}));
                    this.category = null;

                    alert = new Entity.View.Alert(Entity.View.AlertType.SUCCESS, requestSender.getMessage());
                    this.formSender.dispose();
                    this.window.dismiss();
                }
                alert.show();
            });
        }
    }
}
